import type { SelectProps } from '@components/atoms';
import { Select } from '@components/atoms';
import type { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

export type FormSelectProps = SelectProps;

export const FormSelect: FC<FormSelectProps> = props => {
  const { control, formState } = useFormContext();
  const error = formState.errors[props.name];

  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field }) => <Select {...field} {...props} error={error?.message as string} />}
    />
  );
};
